import React, { useEffect, useState } from "react";
import "./WhatsAppLink.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { AppSetup } from "../../utils/apis/common/Common";

const WhatsAppLink = () => {
  const [modalShow, setModalShow] = React.useState(false);

  const [setups, setSetup] = useState();
  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) {
      setSetup(res?.data);
    }
  };

  useEffect(() => {
    getSetup();
  }, []);

  const whatsappLink = /Mobi|Android/i.test(navigator.userAgent)
    ? `https://api.whatsapp.com/send?phone=${setups?.return_exchange}`
    : `https://web.whatsapp.com/send?phone=${setups?.return_exchange}`;

  return (
    <>
      <div className="WhatsAppLink">
        <a target="_blank" rel="noopener noreferrer" href={whatsappLink}>
          <div className="whatsapp_div" type="button">
            <img src="\assets\Image\Icon\whatsapp-icon.png" className="img" />
          </div>
        </a>
      </div>
    </>
  );
};

export default WhatsAppLink;
